import * as configUtils from "util/config";

export const discountsTypes = configUtils.getArray("lotPayments.types", ["PP", "PH"]);
export const discountsOptions = ["thirdPayment.providers", "thirdPayment.assets"];

export const statusTagColor = (state) => {
    switch (state) {
        case "ENVIADO":
            return "warning";
        case "VENCIDO":
            return "info";
        case "RECHAZADO":
            return "error";
        case "APROBADO":
            return "success";
        case "ACTIVO":
            return "success";

        default:
            return "error";
    }
};
export const echeqStates = configUtils.getArray("echecks.states", [
    "TODOS",
    "EMITIDO-PENDIENTE",
    "ACTIVO",
    "CUSTODIA",
    "PRESENTADO",
    "ACTIVO-PENDIENTE",
    "DEVOLUCION-PENDIENTE",
    "REPUDIADO",
    "ANULADO",
    "DEPOSITADO",
    "PAGADO",
    "CADUCADO",
    "NEGOCIACION",
    "NEGOCIACION-PENDIENTE",
    "CESION-PENDIENTE",
    "ACTIVO-PENDIENTE",
]);
export const discountStates2 = configUtils.getArray("discounts.states", [
    "TODOS",
    "ENVIADO",
    "VENCIDO",
    "RECHAZADO",
    "APROBADO",
]);

export const discountStates = [
    {
        value: "PROCESSING.INITIAL",
        label: "Enviado",
    },
    {
        value: "FINISHED.PARTIAL",
        label: "Parcial",
    },
    {
        value: "FAILED.EXPIRED",
        label: "Vencido",
    },
    // {
    //     value: "PENDING",
    //     label: "Pendiente",
    // },
    {
        value: "FINISHED.REJECTED",
        label: "Rechazado",
    },
    {
        value: "FINISHED.APPROVED",
        label: "Aprobado",
    },
];

export const getStatusTagColor = (state) => {
    switch (state) {
        case "INITIAL":
        case "PENDING":
            return "warning";
        case "PARTIAL":
            return "info";
        case "EXPIRED":
        case "REJECTED":
            return "error";
        case "ACTIVO":
        case "APPROVED":
            return "success";

        default:
            return "error";
    }
};

export default discountsTypes;
